if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      this.loadRecommendations();
    }

    loadRecommendations() {
      const requestUrl = this.dataset.url;

      if (!requestUrl) return;

      fetch(requestUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Unable to load product recommendations');
          }

          return response.text();
        })
        .then((responseText) => {
          const container = document.createElement('div');
          container.innerHTML = responseText;

          const loadedSection = container.querySelector(
            'product-recommendations'
          );

          if (!loadedSection) return;

          const products = loadedSection.querySelectorAll(
            '.product-grid .grid__item'
          );

          if (products.length > 0) {
            this.innerHTML = loadedSection.innerHTML;
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((error) => {
          console.warn('Product recommendations:', error);
        });
    }
  }

  customElements.define(
    'product-recommendations',
    ProductRecommendations
  );
}